/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';

import { useHistory } from 'react-router-dom';
import { LoneIconButton } from '@blend/enterprise-components';

const TeamsIconButton: React.FC = () => {
  const history = useHistory();
  return (
    // TODO: replace with Alchemy Icon/Button along with the profile Icon/Button
    <LoneIconButton
      btnSize="sm"
      icon="group"
      iconSize={24}
      id="it-teams-btn"
      key="sa-teams-button"
      onClick={() => history.push('/teams')}
      theme="light"
    />
  );
};

export default TeamsIconButton;
